module.exports = __webpack_public_path__ + "img/devlet-destekli-alacak-sigortasi.4a9b13a6.svg";